import * as React from "react"
import { Block } from "./library/container"
import { MediaBlockProps } from "../../custom_api/drupal_paragraph_to_block"
import { ImageBlock } from "./image_block"
import { VideoBlock } from "./video_block"
import { slugify } from "../../custom_utils/helpers"

interface RichTextInlineMedia {
  position: "text_left" | "text_right"
  media: MediaBlockProps
}

export interface RichTextBlockProps {
  readonly title: string
  readonly html: string
  readonly primaryActionTitle?: string
  readonly primaryActionUrl?: string
  readonly secondaryActionTitle?: string
  readonly secondaryActionUrl?: string
  readonly media: "none" | RichTextInlineMedia
}

export const RichTextBlock: React.StatelessComponent<RichTextBlockProps> = p => {
  const media =
    p.media != "none" && p.media.media.kind == "image" ? (
      <ImageBlock {...p.media.media} />
    ) : p.media != "none" && p.media.media.kind == "video" ? (
      <VideoBlock {...p.media.media} />
    ) : null

  return (
    <Block>
      <div className="richtext-block">
        <h2 data-anchor={slugify(p.title)} className="richtext-block__title title--l">{p.title}</h2>
        <div className={`richtext-block__media-container--${p.media != "none" ? p.media.position + " row" : ""} `}>
          {p.media != "none" && (
            <div className={`richtext-block__media richtext-block__media--${p.media.position} col-xs-12 col-md-4`}>
              {media}
            </div>
          )}
          <div className={`richtext-block__container-buttons ${p.media != "none" ? "col-xs-12 col-md-8" : ""}`}>
            <div dangerouslySetInnerHTML={{ __html: p.html }} className="richtext-block__container" />

            <div className="richtext-block__buttons">
              {p.primaryActionTitle != "" && (
                <a className="button" href={p.primaryActionUrl}>
                  {p.primaryActionTitle}
                </a>
              )}
              {p.secondaryActionTitle != "" && <a href={p.secondaryActionUrl}>{p.secondaryActionTitle}</a>}
            </div>
          </div>
        </div>
      </div>
    </Block>
  )
}
